export const inputClass =
  'w-full px-4 py-3 text-sm text-foreground-800 bg-background-50 border border-secondary-200 rounded-xl focus:outline-none focus:border-primary-400 focus:ring-2 focus:ring-primary-200/50 placeholder:text-foreground-300 transition-all';

export const chipClass = (selected: boolean) =>
  `px-4 py-2 text-sm rounded-full border transition-all cursor-pointer whitespace-nowrap ${
    selected
      ? 'bg-primary-500 text-background-50 border-primary-500 shadow-sm shadow-primary-200/60'
      : 'bg-background-50 text-foreground-600 border-secondary-200 hover:border-primary-300 hover:text-primary-600'
  }`;